// extracted by mini-css-extract-plugin
module.exports = {"localeSelector":"LocaleSelector_localeSelector__eCiIr","label":"LocaleSelector_label__VIZi9"};